// Coduri COR (Clasificarea Ocupatiilor din Romania)
// Sursa: Ordinul MMSS + HG 1352/2010 actualizat
export const COR_CODES = [
  // ===== CONSTRUCTII =====
  { code: "711201", name: "Zidar", group: "Construcții" },
  { code: "711202", name: "Zidar pietrar", group: "Construcții" },
  { code: "711203", name: "Montator prefabricate din beton", group: "Construcții" },
  { code: "711301", name: "Tencuitor", group: "Construcții" },
  { code: "712101", name: "Parchetar", group: "Construcții" },
  { code: "712102", name: "Faianțar-mozaicar", group: "Construcții" },
  { code: "712201", name: "Instalator rețele sanitare de interior", group: "Construcții" },
  { code: "712202", name: "Instalator apă-canal", group: "Construcții" },
  { code: "712301", name: "Instalator sisteme termice", group: "Construcții" },
  { code: "712302", name: "Instalator gaze naturale", group: "Construcții" },
  { code: "712401", name: "Geamgiu-sticlar", group: "Construcții" },
  { code: "712501", name: "Acoperitor-învelitor", group: "Construcții" },
  { code: "712601", name: "Asfaltator", group: "Construcții" },
  { code: "712602", name: "Betonist", group: "Construcții" },
  { code: "712603", name: "Cofreur", group: "Construcții" },
  { code: "712604", name: "Podari-pietruitor", group: "Construcții" },
  { code: "712605", name: "Mecanic utilaj construcții", group: "Construcții" },
  { code: "713101", name: "Zugrav", group: "Construcții" },
  { code: "713102", name: "Vopsitor construcții", group: "Construcții" },
  { code: "713103", name: "Tapețar-decorator", group: "Construcții" },
  { code: "713201", name: "Curățitor clădiri", group: "Construcții" },
  { code: "713401", name: "Dulgher (exclusiv mobilă)", group: "Construcții" },
  { code: "713501", name: "Tâmplar (exclusiv mobilă)", group: "Construcții" },
  { code: "741101", name: "Electrician instalații electrice de joasă tensiune", group: "Construcții" },
  { code: "741201", name: "Electrician instalații electrice de interior", group: "Construcții" },
  { code: "742101", name: "Instalator telecomunicații", group: "Construcții" },
  { code: "931301", name: "Muncitor necalificat la demolarea clădirilor, captuşeli zidărie, plăci mozaic, faianță, gresie, parchet", group: "Construcții" },
  { code: "931302", name: "Muncitor necalificat în construcții-montaj", group: "Construcții" },
  { code: "931303", name: "Sapator", group: "Construcții" },
  // ===== HORECA =====
  { code: "512001", name: "Bucătar", group: "HoReCa" },
  { code: "512002", name: "Ajutor bucătar", group: "HoReCa" },
  { code: "512003", name: "Bucătar-șef", group: "HoReCa" },
  { code: "512004", name: "Cofetar", group: "HoReCa" },
  { code: "512005", name: "Cofetar-patiser", group: "HoReCa" },
  { code: "512006", name: "Brutar", group: "HoReCa" },
  { code: "513001", name: "Chelner (ospătar)", group: "HoReCa" },
  { code: "513002", name: "Barman", group: "HoReCa" },
  { code: "513003", name: "Ajutor ospătar", group: "HoReCa" },
  { code: "513201", name: "Recepționer hotel", group: "HoReCa" },
  { code: "514101", name: "Frizer", group: "HoReCa" },
  { code: "514102", name: "Coafor", group: "HoReCa" },
  { code: "514103", name: "Manichiuristă-pedichiuristă", group: "HoReCa" },
  { code: "514901", name: "Maseur", group: "HoReCa" },
  { code: "911201", name: "Cameristă (hotel)", group: "HoReCa" },
  { code: "911202", name: "Lucrător hotelier (cameră, restaurant, bar)", group: "HoReCa" },
  { code: "911203", name: "Îngrijitor spații de cazare", group: "HoReCa" },
  { code: "941201", name: "Preparator produse din carne și pește", group: "HoReCa" },
  { code: "941202", name: "Preparator produse de panificație", group: "HoReCa" },
  { code: "941901", name: "Ajutor preparator produse alimentare", group: "HoReCa" },
  // ===== AGRICULTURA =====
  { code: "921101", name: "Muncitor în agricultură (culturi de câmp)", group: "Agricultură" },
  { code: "921102", name: "Lucrător agricol", group: "Agricultură" },
  { code: "921103", name: "Muncitor viticultură", group: "Agricultură" },
  { code: "921104", name: "Muncitor pomicultură", group: "Agricultură" },
  { code: "921105", name: "Seră-floricultură muncitor", group: "Agricultură" },
  { code: "921106", name: "Muncitor creștere animale", group: "Agricultură" },
  { code: "921201", name: "Muncitor în silvicultură", group: "Agricultură" },
  { code: "921901", name: "Muncitor necalificat în agricultură, silvicultură", group: "Agricultură" },
  // ===== TRANSPORT =====
  { code: "832101", name: "Șofer autoturism și camionetă", group: "Transport" },
  { code: "832201", name: "Șofer de autocamion", group: "Transport" },
  { code: "832202", name: "Șofer de tractor", group: "Transport" },
  { code: "832301", name: "Șofer de autobuz și autocar", group: "Transport" },
  { code: "834201", name: "Operator macara", group: "Transport" },
  { code: "834202", name: "Operator stivuitor", group: "Transport" },
  { code: "834901", name: "Operator buldozer-excavator", group: "Transport" },
  { code: "835101", name: "Marinar", group: "Transport" },
  // ===== INDUSTRIE / PRODUCȚIE =====
  { code: "721201", name: "Sudor", group: "Industrie" },
  { code: "721202", name: "Sudor autogen", group: "Industrie" },
  { code: "722101", name: "Mecanic auto", group: "Industrie" },
  { code: "722102", name: "Lăcătuș mecanic", group: "Industrie" },
  { code: "722103", name: "Strungar", group: "Industrie" },
  { code: "722104", name: "Frezor", group: "Industrie" },
  { code: "731201", name: "Tâmplar mobilă", group: "Industrie" },
  { code: "731202", name: "Prelucrător lemn", group: "Industrie" },
  { code: "732101", name: "Olar", group: "Industrie" },
  { code: "741301", name: "Electromecanic", group: "Industrie" },
  { code: "741901", name: "Reparator aparate electrocasnice", group: "Industrie" },
  { code: "751101", name: "Măcelar", group: "Industrie" },
  { code: "751102", name: "Preparator mezeluri", group: "Industrie" },
  { code: "751201", name: "Panificator-patiser", group: "Industrie" },
  { code: "753101", name: "Croitor", group: "Industrie" },
  { code: "753102", name: "Confecționer îmbrăcăminte", group: "Industrie" },
  { code: "816001", name: "Operator mașini de prelucrare a lemnului", group: "Industrie" },
  { code: "816101", name: "Operator instalație de prelucrare hârtie", group: "Industrie" },
  { code: "932101", name: "Muncitor necalificat în industria prelucrătoare", group: "Industrie" },
  { code: "932102", name: "Muncitor necalificat în ambalare", group: "Industrie" },
  { code: "932901", name: "Muncitor necalificat în producție", group: "Industrie" },
  // ===== SERVICII =====
  { code: "422101", name: "Funcționar de birou", group: "Servicii" },
  { code: "422201", name: "Operator date", group: "Servicii" },
  { code: "524201", name: "Casier", group: "Servicii" },
  { code: "524901", name: "Vânzător", group: "Servicii" },
  { code: "532101", name: "Îngrijitor persoane vârstnice", group: "Servicii" },
  { code: "532102", name: "Asistent personal", group: "Servicii" },
  { code: "532201", name: "Baby-sitter", group: "Servicii" },
  { code: "541101", name: "Agent de pază și ordine", group: "Servicii" },
  { code: "541102", name: "Guard de securitate", group: "Servicii" },
  { code: "611101", name: "Legumicultor", group: "Servicii" },
  { code: "911101", name: "Îngrijitor clădiri", group: "Servicii" },
  { code: "911102", name: "Femeie de serviciu", group: "Servicii" },
  { code: "912101", name: "Spălătoreasă", group: "Servicii" },
  { code: "912102", name: "Lucrător în spălătorie", group: "Servicii" },
  { code: "951101", name: "Colector deșeuri", group: "Servicii" },
  { code: "952101", name: "Îngrijitor spații verzi", group: "Servicii" },
  { code: "952102", name: "Grădinar", group: "Servicii" },
];

export default COR_CODES;
